/* global $ */
/* global euAdminConfig */

const getUserDetails = (username, userStatus, callback) => {
    const withForwards = ['open', 'trial'].includes(userStatus);

    $.ajax({
        url: `${euAdminConfig.base_uri + euAdminConfig.hostname}/users/${username}/details?withForwards=${withForwards}`,
        type: 'get'
    }).done((data) => {
        callback(data);
    });
};

export default getUserDetails;
